import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { PcMultiSelectFilterComponent } from './pc-multi-select-filter.component';

@NgModule({
  declarations: [PcMultiSelectFilterComponent],
  imports: [CommonModule, FormsModule, MaterialModule],
  exports: [PcMultiSelectFilterComponent],
})
export class PcMultiSelectFilterModule {}
